import { Theme, CSSObject, styled } from "@mui/material/styles";

import { Container as MuiContainer } from "@mui/material";
import theme from "../../styles/theme";

export const StyledWelcome = styled("div")`
    min-height: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
`;

export const PopsLoginButton = styled("button")(({ theme }) => ({
    width: `480px`,
    height: `56px`,
    marginTop: `48px`,
    borderRadius: `3px`,
    border: `0`,
    padding: `0`,
    color: theme.palette.grey.contrastText,
    backgroundColor: theme.palette.grey.dark,
    svg: {
        marginTop: `-3px`,
    },
    strong: {
        display: `inline-block`,
        marginLeft: `24px`,
        fontWeight: `normal`,
    },
}));

// welcome 페이지: 로그인 영역은 가운데, Footer는 하단에 고정한다 (DAM-973)
export const WelcomePage = styled("div")`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

// StyledWelcome은 LX Hausys welcome과 공유하므로 직접 수정하지 않고 확장한다
export const WelcomeBody = styled(StyledWelcome)`
    flex: 1;
    min-height: 0;
    height: auto;
`;

export const FooterWrapper = styled("footer")(({ theme }) => ({
    display: `flex`,
    alignItems: `center`,
    justifyContent: `space-between`,
    flexWrap: `wrap`,
    gap: theme.spacing(1),
    padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
    borderTop: `1px solid ${theme.palette.greySecondary[100]}`,
}));
